//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Nav from "@/components/Nav.vue";
import {mapGetters , mapActions}  from 'vuex';
export default {
  name:'search',
  components: {
    Nav
  },
  computed:{
    ...mapGetters(['readyKeyword'])
  },
  data(){
    return {
      // isNew:true,
      list:[
        // {
        //   type:2,
        //   article:null,
        //   school:{
        //     id:'',
        //     area_title: "",
        //     city_title: "",
        //     cover: "",
        //     fee: "",
        //     grade: "",
        //     is_sprint: false,
        //     province_title: "",
        //     title: "",
        //   }
        // }
      ],
      keywordList:[],
      keyValue:'',
      total:0,
      page:1,
      limit:4,
      isLoading:false,//是否正在加载数据
      showlog:false,
      showEmpty:false
    }
  },
  methods: {
    ...mapActions(['setReadyKeyword']),
    toDetail(item){
      if(item.type==1){
        if(item.article.url){
          window.location.href=item.article.url
        }else{
          this.$router.push({
            name: "popdetais",
            query: {
              id: item.article.id
            }
          });
        }
      }else{
        this.$router.push({
          name: "schoolDetail",
          query: {
            id: item.school.id
          }
        });
      }
      
    },
    hotSearch(keyword){
      this.page = 1
      this.total=0
      this.list=[]
      this.keyValue=keyword
      // this.search(keyword);
      //这里存入keyword
      this.setReadyKeyword(keyword)

      this.showEmpty=false
      this.$api.search({
          params:{
            keyword:keyword,
            limit:this.limit,
            page:this.page
          }
        }).then(res =>{
          if(res.data.success&&res.data.code==0){
            let data = res.data.data
            this.list = this.list.concat(data.items)
            this.total = data.total
            this.showlog = false
            this.isLoading = false
            this.isFirstLoading = true
            if(this.list.length==0){
              this.showEmpty=true
            }
          }else{
            this.$vux.toast.text(res.data.message, "middle");
          }
        })
    },
    navSearch(keyword){
      console.log("keyword==>",keyword);
      this.page = 1
      this.total=0
      this.list=[]
      this.keyValue=keyword

      console.log('this.keyValue==>',this.keyValue);

      //这里存入keyword
      this.setReadyKeyword(keyword)

      this.showEmpty=false
      this.$api.search({
          params:{
            keyword:keyword,
            limit:this.limit,
            page:this.page
          }
        }).then(res =>{
          if(res.data.success&&res.data.code==0){
            let data = res.data.data
            this.list = this.list.concat(data.items)
            this.total = data.total
            this.showlog = false
            this.isLoading = false
    
            if(this.list.length==0){
              this.showEmpty=true
            }
          }else{
            this.$vux.toast.text(res.data.message, "middle");
          }
      })
    },
    search(keyword){
      this.keyValue=keyword
      this.showEmpty=false
      if(keyword!==''){
        this.$api.search({
          params:{
            keyword:keyword,
            limit:this.limit,
            page:this.page
          }
        }).then(res =>{
          if(res.data.success&&res.data.code==0){
            let data = res.data.data
            this.list = this.list.concat(data.items)
            this.total = data.total
            this.showlog = false
            this.isLoading = false
    
            if(this.list.length==0){
              this.showEmpty=true
            }
          }else{
            this.$vux.toast.text(res.data.message, "middle");
          }
        })
      }
    },
    getKeywords(){
      this.$api.getKeywords().then(res =>{
        if(res.data.success&&res.data.code==0){
          let data = res.data.data
          this.keywordList = data.items
        }else{
          this.$vux.toast.text(res.data.message, "middle");
        }
      })
    },
    reset(){
      this.keyValue=''
      this.page = 1
      this.total=0
      this.list=[]
    },
    //监听滚动条下拉
    scrool() {
      let that = this;
      var scrollTop = this.$refs.scrollContent.scrollTop;
      var clientHeight = this.$refs.scrollContent.clientHeight;
      var scrollHeight = this.$refs.scrollContent.scrollHeight;
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (that.limit * that.page < that.total && !that.isLoading) { 
          that.page++;
          that.showlog = true;
          that.isLoading = true
          setTimeout(function() {
            that.search(that.keyValue);
          }, 1500);
        }
      }
    }
  },
  //组件前置守卫
  beforeRouteEnter:(to,from,next)=>{

    if(from.name === 'schoolDetail'){
       next(vm =>{
          console.log('vm==>',vm);
          // vm.isNew = false;
          var keyword = vm.readyKeyword;
          vm.navSearch(keyword);
      });
    }else{
      next();
    }

  },
  
  // watch: {
  //     $route() {
  //       if (this.$route) {
  //         if(this.$route.name === 'search'){
  //           console.log('开始搜索');
  //            //输出看看
  //           console.log("看看有没有==>",this.readyKeyword);

  //           if(this.readyKeyword){
              
  //           }
  //         }
  //       }
  //     }
  // },
  created() {
 
      this.getKeywords();
    


   


    //初始化的时候，如果vuex里面有keyword的话，获取keyword 然后初始化搜索组件，然后搜索一下
    /*
      1.先存储进去vuex
    */



    // var that=this
    // window.onscroll = function() {
    //   //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是可视区的高度
    //   var windowHeight =
    //     document.documentElement.clientHeight || document.body.clientHeight; //变量scrollHeight是滚动条的总高度
    //   var scrollHeight =
    //     document.documentElement.scrollHeight || document.body.scrollHeight; //滚动条到底部的条件
    //   if (scrollTop + windowHeight == scrollHeight) {
    //     if (that.limit * that.page < that.total) {
    //         that.page++;
    //         that.search(that.keyValue)
    //     }        
    //   }
    // }
  },
  mounted() {
    this.$refs.scrollContent.addEventListener("scroll", this.scrool);
  },
  activated() {
      this.page = 1
      this.total=0
      this.list=[]
      this.keyValue=''

  },
};



// WEBPACK FOOTER //
// ./src/pages/search.vue